import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	delete: {
		id: 'backlog.modals.card-delete-modal.delete',
		defaultMessage: 'Delete',
		description: '',
	},
	cancel: {
		id: 'backlog.modals.card-delete-modal.cancel',
		defaultMessage: 'Cancel',
		description: '',
	},
	title: {
		id: 'backlog.modals.card-delete-modal.title',
		defaultMessage: 'Delete {cardKey}?',
		description: '',
	},
	titleIssueTerminologyRefreshM4: {
		id: 'backlog.modals.card-delete-modal.title-issue-terminology-refresh-m4',
		defaultMessage: 'Permanently delete {workType} {cardKey}',
		description: 'Please translate as “work type {workType}”',
	},
	deleteDataPermanentlyWarning: {
		id: 'backlog.modals.card-delete-modal.delete-data-permanently-warning',
		defaultMessage:
			"You're about to permanently delete this issue, its comments and attachments, and all of its data.",
		description: '',
	},
	deleteDataPermanentlyWarningIssueTerminologyRefreshM4: {
		id: 'backlog.modals.card-delete-modal.delete-data-permanently-warning-issue-terminology-refresh-m4',
		defaultMessage:
			'This {workType} and all its subtasks, comments, attachments, and data will be permanently deleted.',
		description: 'Please translate as “work type {workType}”',
	},
	resolveOrCloseInstead: {
		id: 'backlog.modals.card-delete-modal.resolve-or-close-instead',
		defaultMessage: "If you're not sure, you can resolve or close this issue instead.",
		description: '',
	},
	resolveOrCloseInsteadIssueTerminologyRefreshM4: {
		id: 'backlog.modals.card-delete-modal.resolve-or-close-instead-issue-terminology-refresh-m4',
		defaultMessage: "If you're not sure, you can resolve or close this {workType} instead.",
		description: 'Please translate as “work type {workType}”',
	},
	deleteDataPermanentlyWarningIssueTermRefresh: {
		id: 'backlog.modals.card-delete-modal.delete-data-permanently-warning-issue-term-refresh',
		defaultMessage:
			"You're about to permanently delete this work item, its comments and attachments, and all of its data.",
		description: '',
	},
	resolveOrCloseInsteadIssueTermRefresh: {
		id: 'backlog.modals.card-delete-modal.resolve-or-close-instead-issue-term-refresh',
		defaultMessage: "If you're not sure, you can resolve or close this work item instead.",
		description: '',
	},
});
